import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import ProductOrStateRulesPanel from '../../../productOrStateRules/ProductOrStateRulesPanel';
import FreeAdvancesPanel from '../FreeAdvancesPanel';
import formStyles from '../../styles/feeStructureForm.module.scss';
import styles from '../freeAdvances/styles/freeAdvances.module.scss';

/**
 * The Geography sub-tab: the advance fee and free advances for members who
 * live in the selected states (the state on their identity address). Both
 * lists are part of `fee_rules`, saved with the Fee Structure tab's own Save
 * button. Laid out like the Free Advances tab.
 */
function GeographyTab({ rules = {}, options = {}, handlers = {} }) {
    return (
        <div className={styles.tab}>
            <div>
                <div className={styles.sectionHeader}>
                    <Text as="span" size="m" className={styles.sectionTitle}>
                        Fees
                    </Text>
                </div>
                <Text as="span" size="s" className={styles.sectionDescription}>
                    Set the advance fee for members who live in the selected states.
                </Text>
                <ProductOrStateRulesPanel
                    rules={rules.geographyRules}
                    matchKey="states"
                    options={options.states}
                    prefix="if the member lives in"
                    valueLabel="the advance fee is"
                    valueKey="fee"
                    inputProps={{
                        prefix: (
                            <Text as={TextAs.SPAN} size={TextSizes.SMALL}>
                                $
                            </Text>
                        ),
                        min: 0,
                        max: 999.99,
                        step: 0.01,
                        precision: 2,
                    }}
                    onAdd={handlers.addGeographyRule}
                    onRemove={handlers.removeGeographyRule}
                    onUpdate={handlers.updateGeographyRule}
                    addLabel="Add a state row"
                    emptyTitle="No state fee rules yet"
                    emptyDescription="Add a row to set a custom advance fee for members in one or more states."
                    classNames={{
                        row: formStyles.ruleRow,
                        label: formStyles.ruleLabel,
                        select: `${formStyles.select} ${formStyles.selectMd}`,
                        input: `${formStyles.inlineNumberInput} ${formStyles.amountField}`,
                    }}
                />
            </div>

            <hr className={styles.divider} />

            <div>
                <div className={styles.sectionHeader}>
                    <Text as="span" size="m" className={styles.sectionTitle}>
                        Free advances
                    </Text>
                </div>
                <Text as="span" size="s" className={styles.sectionDescription}>
                    Grant members who live in the selected states a number of fee-free advances.
                </Text>
                <FreeAdvancesPanel
                    rules={rules.geographyFreeAdvanceRules}
                    stateOptions={options.states}
                    onAdd={handlers.addGeographyFreeAdvanceRule}
                    onRemove={handlers.removeGeographyFreeAdvanceRule}
                    onUpdate={handlers.updateGeographyFreeAdvanceRule}
                />
            </div>
        </div>
    );
}

export default GeographyTab;
